module.exports = __webpack_public_path__ + "static/media/logo_youbiz.f5681e08.svg";